(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2573],{

/***/ 83593:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"linkContainer":"linkContainer--6683c","wrapper":"wrapper--414bf","disabled":"disabled--d01ee","md":"md--3ea20","lg":"lg--0aa25","primary":"primary--e6ac1","primaryAlternative":"primaryAlternative--21c3c","secondary":"secondary--083ec","secondaryNoUnderline":"secondaryNoUnderline--671ac","secondaryNoUnderlineNoHover":"secondaryNoUnderlineNoHover--943ba","tertiary":"tertiary--78a25","tertiaryNoUnderline":"tertiaryNoUnderline--76f0e","tertiaryNoUnderlineNoHover":"tertiaryNoUnderlineNoHover--d8a01"};

/***/ }),

/***/ 27555:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"linkContainer":"linkContainer--9a582","wrapper":"wrapper--16f25","disabled":"disabled--5f59c","md":"md--4a060","lg":"lg--62191","primary":"primary--96c5d","primaryAlternative":"primaryAlternative--74416","secondary":"secondary--3fc6a","secondaryNoUnderline":"secondaryNoUnderline--6dc24","secondaryNoUnderlineNoHover":"secondaryNoUnderlineNoHover--e0a4f","tertiary":"tertiary--f41b0","tertiaryNoUnderline":"tertiaryNoUnderline--cbbed","tertiaryNoUnderlineNoHover":"tertiaryNoUnderlineNoHover--f945f"};

/***/ }),

/***/ 14160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useTracking; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);
/* harmony import */ var _TrackingProvider_TrackingProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82725);


function useTracking() {
    var ctx = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_TrackingProvider_TrackingProvider__WEBPACK_IMPORTED_MODULE_1__/* .TrackingContext */ .U);
    if (!ctx) {
        throw new Error("useTracking must be used within TrackingProvider");
    }
    return ctx;
}


/***/ }),

/***/ 50828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K$": function() { return /* binding */ MoveCartItemToDrafts; },
/* harmony export */   "Xr": function() { return /* binding */ AddOrderedSampleItemToCart; },
/* harmony export */   "ee": function() { return /* binding */ AddOrderedItemToCart; },
/* harmony export */   "er": function() { return /* binding */ UpdateCartItems; },
/* harmony export */   "vP": function() { return /* binding */ RemoveCartItems; }
/* harmony export */ });
/* unused harmony exports GetCartDetails, ApplyCoupon, RemoveCoupon, GetCart */
var GetCartDetails = '\n  query GetCartDetails {\n    cart {\n      details {\n        storeCartId\n        currencyCode\n        coupons {\n          id\n          code\n          discountedAmount\n        }\n        items {\n          catalogProductId\n          id\n          parentId\n          collectionName\n          accessories {\n            liner {\n              catalogProductSlug\n              id\n              catalogProduct {\n                name\n              }\n              images(input: { role: { equal: "front" } }) {\n                role\n                url\n              }\n            }\n            plainEnvelope {\n              catalogProductSlug\n              id\n            }\n            printedEnvelope {\n              catalogProductSlug\n              id\n              catalogProduct {\n                name\n              }\n              images(input: { role: { equal: "front" } }) {\n                role\n                url\n              }\n            }\n          }\n          related {\n            liner {\n              slug\n              variationId\n            }\n            plainEnvelopeId\n            printedEnvelope {\n              slug\n              variationId\n            }\n          }\n          portfolioItem {\n            customizer {\n              stateId\n              urlPrint\n              urlProofs {\n                position\n                url\n              }\n              userId\n            }\n            id\n            memberId\n            notes\n            tenant\n            urlPrintOverride\n            variationId\n            isCustomized\n          }\n          price {\n            bulkPrices {\n              amount\n              quantity\n            }\n          }\n          slug\n          productName\n          productPhotos {\n            back\n            front\n            frontAndBack\n            hero\n            suite\n          }\n          quantity\n          totalAmount\n          variation {\n            catalogProductId\n            colorThemeCode\n            optionValues {\n              name\n              valueId\n              optionId\n            }\n            envelopePrintingOptionCode\n            foilCode\n            id\n            isSample\n            paperTypeCode\n            productCode\n            flapTypeCode\n            suiteCode\n            tenant\n            optionValues {\n              optionId\n              name\n              valueId\n            }\n            product {\n              productFormat {\n                name\n              }\n            }\n            optionValues {\n              name\n              optionId\n              valueId\n            }\n          }\n          colorThemeName\n          paperTypeName\n          foilThemeName\n          envelopePrintingName\n          designedBy\n          productTypeName\n        }\n        totalAmount\n      }\n      itemCount\n    }\n  }\n';
var ApplyCoupon = "\n  mutation ApplyCoupon($couponCode: String!) {\n    cart {\n      applyCoupon(couponCode: $couponCode) {\n        storeCartId\n        coupons {\n          id\n          code\n          discountedAmount\n        }\n      }\n    }\n  }\n";
var RemoveCoupon = "\n  mutation RemoveCoupon($couponCode: String!) {\n    cart {\n      removeCoupon(couponCode: $couponCode) {\n        storeCartId\n      }\n    }\n  }\n";
var AddOrderedItemToCart = "\n  mutation AddOrderedItemToCart($input: AddItemToCartInput!) {\n    cart {\n      addItem(input: $input) {\n        cart {\n          storeCartId\n        }\n        item {\n          totalAmount\n        }\n      }\n    }\n  }\n";
var AddOrderedSampleItemToCart = "\n  mutation AddOrderedSampleItemToCart($input: AddItemToCartInput!) {\n    cart {\n      addItem(input: $input) {\n        item {\n          portfolioItem {\n            id\n          }\n        }\n      }\n    }\n  }\n";
var VariationData = "\n  fragment VariationData on CatalogProductVariationGraphqlModel {\n    id\n    isSample\n    catalogProductTypeCode\n    images {\n      url\n      role\n    }\n    priceTiers: friendlyPriceTiers {\n      quantity\n      totalAmount\n    }\n\n    optionValues {\n      optionId\n      valueId\n      name\n    }\n    catalogProduct {\n      name\n      slug\n      externalId\n      catalogProductFormat {\n        name\n      }\n      catalogProductCategory {\n        name\n      }\n    }\n  }\n";
var Variation = /* GraphQL */ "\n  fragment Variation on CartDetailsItem {\n    variation: displayVariation {\n      ...VariationData\n    }\n  }\n  ".concat(VariationData, "\n");
var Portfolio = "\n  fragment Portfolio on CartDetailsItem {\n    portfolio: portfolioItem {\n      id\n      notes\n      customizer {\n        urlProofs {\n          url\n          position\n        }\n      }\n    }\n  }\n";
var Accessories = '\n  fragment Accessories on CartDetailsItem {\n    accessories {\n      liner {\n        id\n        catalogProduct {\n          name\n          slug\n        }\n        images(input: { role: { equal: "front" } }) {\n          role\n          url\n        }\n      }\n      plainEnvelope {\n        ...VariationData\n      }\n      printedEnvelope {\n        id\n        catalogProduct {\n          name\n          slug\n        }\n        images(input: { role: { equal: "front" } }) {\n          role\n          url\n        }\n      }\n    }\n  }\n';
var Details = /* GraphQL */ "\n  fragment Details on CartDetails {\n    storeCartId\n    totalAmount\n    cartAmount\n    items {\n      id\n      quantity\n      totalAmount\n      parentId\n      productTypeName\n      ...Portfolio\n      ...Variation\n      ...Accessories\n    }\n  }\n  ".concat(Variation, "\n  ").concat(Portfolio, "\n  ").concat(Accessories, "\n");
var GetCart = /* GraphQL */ "\n  query getCart {\n    cart {\n      details {\n        ...Details\n      }\n    }\n  }\n  ".concat(Details, "\n");
var RemoveCartItems = "\n  mutation removeCartItems($input: RemoveFromCartInput!) {\n    cart {\n      removeItems(input: $input) {\n        cart {\n          storeCartId\n        }\n      }\n    }\n  }\n";
var UpdateCartItems = "\n  mutation updateCartItems($input: UpdateCartItemInput!) {\n    cart {\n      updateItems(input: $input) {\n        cart {\n          storeCartId\n        }\n      }\n    }\n  }\n";
var MoveCartItemToDrafts = "\n  mutation moveCartItemToDrafts($itemId: String!) {\n    draftCart {\n      moveCartItemToDrafts(itemId: $itemId) {\n        cart {\n          storeCartId\n        }\n        draft {\n          id\n        }\n      }\n    }\n  }\n";


/***/ }),

/***/ 78621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kI": function() { return /* binding */ CartItemCount; },
/* harmony export */   "xL": function() { return /* binding */ AddItemToCart; }
/* harmony export */ });
/* unused harmony exports RemoveFromCart, UpdateCart */
// FOUNDATION - Remove when integrating Cart page
//TODO: MUST BE REMOVED??
var CartItemCount = "\n  query CartItemCount {\n    cart {\n      itemCount\n    }\n  }\n";
var AddItemToCart = "\n  mutation AddItemToCart($input: AddItemToCartInput!) {\n    cart {\n      addItem(input: $input) {\n        cart {\n          totalAmount\n          storeCartId\n          items {\n            productName\n            quantity\n            totalAmount\n            id\n          }\n        }\n        item {\n          productName\n          id\n          totalAmount\n          quantity\n          portfolioItem {\n            id\n          }\n        }\n      }\n    }\n  }\n";
var RemoveFromCart = "\n  mutation RemoveFromCart($input: RemoveFromCartInput!) {\n    cart {\n      removeItems(input: $input) {\n        cart {\n          totalAmount\n          items {\n            productName\n            quantity\n            totalAmount\n            id\n          }\n        }\n      }\n    }\n  }\n";
var UpdateCart = "\n  mutation UpdateCart($input: UpdateCartItemInput!) {\n    cart {\n      updateItems(input: $input) {\n        cart {\n          totalAmount\n        }\n        items {\n          id\n          quantity\n          totalAmount\n        }\n      }\n    }\n  }\n";


/***/ }),

/***/ 69333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fe": function() { return /* binding */ MembershipAuthIntents; },
/* harmony export */   "g$": function() { return /* binding */ extractCredentials; },
/* harmony export */   "jx": function() { return /* binding */ createSignupOptions; },
/* harmony export */   "yg": function() { return /* binding */ parseMembershipModalError; }
/* harmony export */ });
var paperUserMarketingOptins = {
    TKThirdPartyInfo: true,
    TKStagesNews: true,
    TKKnotNews: true,
    TKNewsflashNews: true,
    TKKnotShopNews: true
};
var parseMembershipModalError = function(error) {
    try {
        var errorObject = error.body ? error.body.errors[0] : error.response.body.errors[0];
        var errorMessage = errorObject.field ? "".concat(errorObject.field, " ").concat(errorObject.detail) : errorObject.detail;
        return errorMessage;
    } catch (error1) {
        return "Oops ! A problem occurred";
    }
};
var createSignupOptions = function(email, password, userAction) {
    return {
        email: email,
        password: password,
        brand: "theknot",
        application: "paper",
        action: userAction,
        optins: paperUserMarketingOptins
    };
};
var _email, _password;
var extractCredentials = function(data) {
    return {
        email: (_email = data.email) !== null && _email !== void 0 ? _email : data.data.email,
        password: (_password = data.password) !== null && _password !== void 0 ? _password : data.data.password
    };
};
var MembershipAuthIntents = {
    logIn: "LOG_IN",
    signUp: "SIGN_UP"
};


/***/ }),

/***/ 62292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NS": function() { return /* binding */ AuthOptions; },
/* harmony export */   "SV": function() { return /* binding */ navigationLinksData; },
/* harmony export */   "VU": function() { return /* binding */ loginRoute; },
/* harmony export */   "fH": function() { return /* binding */ navigationFooterLinksData; },
/* harmony export */   "x4": function() { return /* binding */ login; }
/* harmony export */ });
var HOST = String("https://www.theknot.com");
var loginRoute = HOST + "/users-login.php";
var AuthOptions;
(function(AuthOptions) {
    AuthOptions["login"] = "login";
    AuthOptions["signUp"] = "signUp";
})(AuthOptions || (AuthOptions = {}));
var login = [
    {
        id: AuthOptions.signUp,
        content: "Join now",
        href: HOST + "/users-signup.php",
        redirectPath: "redirect"
    },
    {
        id: AuthOptions.login,
        content: "Log in",
        href: loginRoute,
        redirectPath: "r"
    }, 
];
var invitationsNavigationLinksData = [
    {
        content: "Wedding Invitations",
        href: HOST + "/wedding-paper/wedding-invitations"
    },
    {
        content: "Save the Dates",
        href: HOST + "/wedding-paper/save-the-date-cards"
    },
    {
        content: "Change the Dates",
        href: HOST + "/wedding-paper/change-the-date-cards"
    },
    {
        content: "Ceremony & Reception",
        href: HOST + "/wedding-paper/ceremony-reception"
    },
    {
        content: "Thanks Yous",
        href: HOST + "/wedding-paper/thank-yous"
    },
    {
        content: "Get a Free Sample Kit",
        href: HOST + "/wedding-paper/page/free-wedding-invitation-samples",
        colorPrimary: true
    }, 
];
var navigationLinksData = [
    {
        content: "Planning Tools",
        href: HOST + "/wedding-planning.html"
    },
    {
        content: "Venues",
        href: HOST + "/wedding-venues"
    },
    {
        content: "Vendors",
        href: HOST + "/wedding-vendors"
    },
    {
        content: "Forums",
        href: HOST + "/wedding-forums",
        mutableDesktop: true,
        mutableTablet: true
    },
    {
        content: "Dresses",
        href: HOST + "/wedding-photos/dresses"
    },
    {
        content: "Ideas",
        href: HOST + "/wedding-ideas"
    },
    {
        content: "Registry",
        href: HOST + "/wedding-registry/manage"
    },
    {
        content: "Wedding website",
        href: HOST + "/wedding-websites.html",
        mutableTablet: true
    },
    {
        content: "Invitations",
        href: HOST + "/wedding-paper",
        submenu: invitationsNavigationLinksData
    },
    {
        content: "Shop",
        href: "https://www.weddingwireshop.com?utm_source=weddingwire&utm_medium=referral&utm_campaign=Shop_Nav",
        target: "_blank"
    }, 
];
var navigationFooterLinksData = [
    {
        content: "WeddingWire Planning App",
        href: HOST + "/app-download.php",
        bordered: true,
        primary: true
    },
    {
        content: "WeddingWire Guest App",
        href: HOST + "/guests/app",
        primary: true
    },
    {
        content: "Help",
        href: "https://support.weddingwire.com/hc/en-us",
        target: "_blank",
        bordered: true
    },
    {
        content: "Privacy Policy",
        href: HOST + "/corp/legal/privacy-policy"
    },
    {
        content: "Term of use",
        href: HOST + "/corp/legal/terms-of-use"
    },
    {
        content: "Do not sell my info",
        href: HOST + "/privacy/noSaleForm"
    },
    {
        content: "Are you a vendor?",
        href: HOST + "/vendors/login"
    },
    {
        content: "Find a couple’s website",
        href: "https://www.weddingwire.us/"
    }, 
];


/***/ }),

/***/ 39313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getUrlToExternalApp; },
/* harmony export */   "f": function() { return /* binding */ routeToExternalApp; }
/* harmony export */ });
var isValidUrl = function(s) {
    try {
        new URL(s);
        return true;
    } catch (e) {
        return false;
    }
};
var getUrlToExternalApp = function(path) {
    if (isValidUrl(path)) return path;
    return "".concat("/paper").concat(path);
};
var routeToExternalApp = function(path) {
    var url = getUrlToExternalApp(path);
    window.location.assign(url);
};


/***/ }),

/***/ 44030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ ImageTKWW; }
/* harmony export */ });
/* unused harmony exports TRANSFORM_URL, CROP_URL, SIZES */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72730);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72491);
/* harmony import */ var _modules_core_services_honeybadger_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69354);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96645);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55323);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99084);










var TRANSFORM_URL = "/transform~rs_";
var CROP_URL = "~sc_";
var shouldBuildSrc = function(path) {
    return path.indexOf("".concat("https://media-api.xogrp.com", "/images/fetch")) < 0;
};
var shouldTransform = function(path) {
    return !/~rs_/.test(path);
};
var appendTransform = function(param) {
    var src = param.src, oneSize = param.oneSize, crop = param.crop, width = param.width;
    if (oneSize && crop) {
        return "".concat(src).concat(TRANSFORM_URL).concat(oneSize, ".").concat(oneSize, "-fit").concat(CROP_URL).concat(oneSize);
    }
    if (oneSize) {
        return "".concat(src).concat(TRANSFORM_URL).concat(oneSize, ".h-fit");
    }
    if (crop) {
        return "".concat(src).concat(TRANSFORM_URL).concat(width, ".").concat(width, "-fit").concat(CROP_URL).concat(width, ".").concat(width);
    }
    return "".concat(src).concat(TRANSFORM_URL).concat(width, ".h-fit");
};
var SIZES = [
    {
        w: 640,
        size: 600
    },
    {
        w: 828,
        size: 600
    },
    {
        w: 1200,
        size: 900
    },
    {
        w: 1600,
        size: 1200
    },
    {
        w: 3840,
        size: 1200
    }, 
];
var ImageTKWW = function(_param) {
    var crop = _param.crop, oneSize = _param.oneSize, forceTransform = _param.forceTransform, noCache = _param.noCache, elementProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "crop",
        "oneSize",
        "forceTransform",
        "noCache"
    ]);
    var getSize = function(width) {
        var foundSize = SIZES.find(function(param) {
            var w = param.w;
            return width <= w;
        });
        return (foundSize === null || foundSize === void 0 ? void 0 : foundSize.size) || SIZES[SIZES.length - 1].size;
    };
    var loadImage = function(param) {
        var src = param.src, width = param.width;
        var url = src;
        if (shouldBuildSrc(src)) {
            url = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .buildSrc */ .ZA)(src);
        }
        if (oneSize) {
            if (shouldTransform(src)) {
                url = appendTransform({
                    src: url,
                    crop: crop,
                    oneSize: oneSize
                });
            }
        }
        var size = getSize(width);
        if (shouldTransform(src)) {
            url = appendTransform({
                src: url,
                crop: crop,
                width: size
            });
        }
        // media api will cache items by default, so we need to append a refetch query param
        // to avoid this behavior when caching is not desired
        if (noCache) {
            url = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .appendRefetch */ .tl)(url);
            url = "".concat(url, "&t=").concat(Date.now());
        }
        return url;
    };
    var ref;
    var width = (ref = oneSize !== null && oneSize !== void 0 ? oneSize : elementProps.width) !== null && ref !== void 0 ? ref : 1200;
    var ref1;
    var height = (ref1 = oneSize !== null && oneSize !== void 0 ? oneSize : elementProps.height) !== null && ref1 !== void 0 ? ref1 : 1200;
    var url = elementProps.src;
    if (forceTransform || shouldBuildSrc(elementProps.src)) {
        url = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .buildSrc */ .ZA)(elementProps.src);
        url = loadImage({
            src: String(url),
            width: parseInt("".concat(width))
        });
    }
    // this useEffect will conditionally re-fetch the src of the image with a no-cache header,
    // thus invalidating the browser cache
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        function invalidateBrowserCache() {
            return _invalidateBrowserCache.apply(this, arguments);
        }
        function _invalidateBrowserCache() {
            _invalidateBrowserCache = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                var result;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    try {
                        result = fetch(url.split("&")[0], {
                            method: "GET",
                            cache: "no-cache"
                        });
                    } catch (e) {
                        _modules_core_services_honeybadger_service__WEBPACK_IMPORTED_MODULE_7__["default"].notify("Unable to fetch proof image with no-cache header ".concat(url), {
                            name: "failedToInvalidateProofImageCache",
                            context: {
                                url: url
                            }
                        });
                    }
                    return [
                        2
                    ];
                });
            });
            return _invalidateBrowserCache.apply(this, arguments);
        }
        if (noCache) invalidateBrowserCache();
    }, [
        url,
        noCache
    ]);
    var _alt, _alt1;
    return noCache ? // there is currently no easy way to disable the next file system cache, so we use a raw img
    // tag when we want to avoid caching
    // eslint-disable-next-line @next/next/no-img-element
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, elementProps), {
        src: url,
        alt: (_alt = elementProps.alt) !== null && _alt !== void 0 ? _alt : "",
        width: width,
        height: height
    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, elementProps), {
        src: url,
        loader: loadImage,
        width: width,
        height: height,
        alt: (_alt1 = elementProps.alt) !== null && _alt1 !== void 0 ? _alt1 : ""
    }));
};


/***/ })

}]);